import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";
import {GraphOptionsBuilder} from "../../lq_js_common/e_charts/chart_builder";
import {
    attachDirectionHint,
    applySplitDirectionAxes,
    createBoundedAxisTooltip,
    finalizeSplitDirectionChart,
    formatPercentFromHundredthsAxis,
    formatTimeTick,
} from "../../helpers/chart_common";

export class ShaperSiteRetransmits extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
    }

    title() {
        return "Site TCP Retransmits";
    }

    supportsZoom() {
        return true;
    }

    tooltip() {
        return "<h5>Site TCP Retransmits</h5><p>Shows the percentage of TCP retransmits over time.</p>";
    }

    buildContainer() {
        let base = super.buildContainer();
        attachDirectionHint(base);
        base.appendChild(this.graphDiv());
        return base;
    }

    setup() {
        super.setup();
        this.graph = new ShaperSiteRetransmitsGraph(this.graphDivId());
        if (this.lastGraphState !== null) {
            this.graph.update(this.lastGraphState);
        }
    }

    channelRequests() {
        return [ "SiteDetail" ];
    }

    onMessage(msg) {
        if (msg.Data.target !== "site_detail") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }
        for (const [key, value] of Object.entries(msg.Data.blob[0])) {
            this.graph.update(value);
            this.lastGraphState = value;
        }
    }

}

class ShaperSiteRetransmitsGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = new GraphOptionsBuilder()
            .withLeftGridSize(75)
            .withTimeAxis()
            .withScaledAbsYAxis("% Retransmits", 50)
            .withEmptyLegend()
            .withEmptySeries()
            .build();
        // Add tooltip
        this.option.tooltip = {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: 'rgba(30,30,30,0.92)',
                    color: '#fff',
                    fontFamily: 'inherit',
                    formatter: function(params) {
                        if (params.axisDimension === 'x') {
                            return new Date(params.value * 1000).toLocaleString();
                        }
                        return (Math.abs(params.value) / 100).toFixed(2) + '%';
                    }
                }
            },
            backgroundColor: 'rgba(30,30,30,0.92)',
            textStyle: {
                fontSize: 10,
                color: '#fff',
                fontFamily: 'inherit'
            },
            formatter: function(params) {
                if (!params || params.length === 0) return '';
                let result = '<div style="font-size: 10px;">';
                result += new Date(params[0].axisValue * 1000).toLocaleString() + '<br/>';
                
                params.forEach(function(p) {
                    let value = Math.abs(p.value) / 100;
                    if (p.seriesName === 'Retransmits Down') {
                        result += `Retransmits Down: ${value.toFixed(2)}%<br/>`;
                    } else if (p.seriesName === 'Retransmits Up') {
                        result += `Retransmits Up: ${value.toFixed(2)}%<br/>`;
                    }
                });
                
                result += '</div>';
                return result;
            }
        };
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();

        this.option.legend = { show: false, data: [] };
        applySplitDirectionAxes(this.option, {
            ticks: data.body.ticks || [],
            topLabel: "Download",
            bottomLabel: "Upload",
            yFormatter: formatPercentFromHundredthsAxis,
        });
        this.option.series = [
            { name: "Download", type: "line", data: [], smooth: true, showSymbol: false, xAxisIndex: 0, yAxisIndex: 0 },
            { name: "Upload", type: "line", data: [], smooth: true, showSymbol: false, xAxisIndex: 1, yAxisIndex: 0 }
        ];

        for (let x=0; x<data.body.active_circuits.length; x++) {
            this.option.series[0].data.push(data.body.retransmits_down_percent[x]);
            this.option.series[1].data.push(0 - data.body.retransmits_up_percent[x]);
        }

        this.option.tooltip = createBoundedAxisTooltip({
            linkAllXAxes: true,
            yFormatter: formatPercentFromHundredthsAxis,
            formatter: (params) => {
                if (!params || params.length === 0) return "";
                const timeIndex = params[0].dataIndex;
                return `<div style="font-size: 10px;">
${formatTimeTick(params[0].axisValue)}<br/>
<strong>Download</strong>: ${formatPercentFromHundredthsAxis(data.body.retransmits_down_percent[timeIndex], 2)}<br/>
<strong>Upload</strong>: ${formatPercentFromHundredthsAxis(data.body.retransmits_up_percent[timeIndex], 2)}
</div>`;
            },
        });

        finalizeSplitDirectionChart(this.option);
        this.chart.setOption(this.option, true);
    }
}
